import React, { useState } from "react";
import {
  CheckCircleOutlined,
  LoginOutlined,
  ShoppingCartOutlined,
  StarFilled,
} from "@ant-design/icons";
import { Avatar, Card, Row, Col, Button, message, Space, Tag } from "antd";
import { Link } from "react-router-dom";
import Payment from "../pages/Payment";
import { HouseAddFill, Trash3Fill } from "react-bootstrap-icons";
import { useDispatch, useSelector } from "react-redux";
import { DeleteCourseService } from "../services/courses/delete";
import {
  EnrollCoursePaymentService,
  EnrollCourseService,
} from "../services/courses/enroll";
import { GetProfileService } from "../services/auth/getprofile";

const { Meta } = Card;

const CourseCard = ({
  id,
  title,
  description,
  rating,
  price,
  imageUrl,
  user,
  tags,
}) => {
  const { isLoggedIn } = useSelector((state) => state.verify).result;
  const getuser = useSelector((state) => state.getuser).result;
  const [showPayment, setShowPayment] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [deleting, setSetDeleting] = useState(false);
  const [enrolling, setSetEnrolling] = useState(false);
  const dispatch = useDispatch();
  const handleCartClick = () => {
    setShowPayment(true);
  };

  const handlePaymentCancel = () => {
    setShowPayment(false);
  };

  const handleDeleteCourse = async () => {
    setSetDeleting(true);
    const key = "updatable";
    messageApi.open({
      key,
      type: "loading",
      content: "Loading...",
    });

    const res = await DeleteCourseService(id, getuser?.result._id, dispatch);
    messageApi.open({
      key,
      type: "success",
      content: res,
    });
    setSetDeleting(false);
    return;
  };
  const handleEnroll = async () => {
    setSetEnrolling(true);
    const key = "updatable";
    messageApi.open({
      key,
      type: "loading",
      content: "Loading...",
    });
    if (price > 0) {
      const res = await EnrollCoursePaymentService(
        price,
        id,
        getuser?.result._id,
        dispatch
      );
      console.log("res:", res);
      // TODO add payment confirmation modal here and redirect to course page after successful transaction
      messageApi.open({
        key,
        type: "success",
        content: "Please Wait..",
      });
    } else {
      const res = await EnrollCourseService(id, getuser?.result._id);
      messageApi.open({
        key,
        type: "success",
        content: res,
      });
      await GetProfileService(getuser?.result._id, dispatch);
      window.location.replace(`/dashboard/courses/${id}`);
    }
    return;
  };

  return (
    <>
      {contextHolder}
      {/* <Card
        style={{
          width: 300,
          margin: "20px",
          borderRadius: "10px",
          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
        }}
        cover={
          <Link
            to={isLoggedIn ? `/dashboard/courses/${id}` : `/viewCourse/${id}`}
            style={{ height: "200px", overflow: "hidden" }}
          >
            <img
              alt="course cover"
              src={
                imageUrl ||
                "https://gw.alipayobjects.com/zos/rmsportal/JiqGstEfoWAOHiTxclqi.png"
              }
            />
          </Link>
        }
        actions={[
          <div className="course-details">
            <Row justify="center" align="middle">
              <Col>
                <div className="price mr-6" style={{ fontSize: "16px" }}>
                  {price}
                </div>
              </Col>
              {isLoggedIn && getuser?.result?.Courses?.indexOf(id) != -1 && (
                <>
                  <Col className="flex justify-between flex-row py-3 w-100">
                    <Link to={`/dashboard/courses/${id}`}>
                      <Button
                        className={`mx-3 bg-pink-500 hover:bg-pink-400 w-${
                          getuser?.result?.isTeacher ? "40" : "60"
                        }`}
                        icon={<CheckCircleOutlined />}
                        type="primary"
                      >
                        {getuser?.result?.isTeacher ? "Open" : "Enrolled"}
                      </Button>
                    </Link>
                    {getuser.result.isTeacher && (
                      <Button
                        className=""
                        icon={<Trash3Fill />}
                        loading={deleting}
                        type="link"
                        danger
                        onClick={handleDeleteCourse}
                      >
                        {deleting ? "Deleting..." : "Delete"}
                      </Button>
                    )}
                  </Col>
                </>
              )}
              {isLoggedIn &&
                !getuser?.result?.isTeacher &&
                getuser?.result?.Courses?.indexOf(id) === -1 && (
                  <Col>
                    <Button
                      className="mx-3 bg-green-500 hover:bg-green-400"
                      icon={<HouseAddFill />}
                      type="primary"
                      loading={enrolling}
                      onClick={handleEnroll}
                    >
                      {enrolling ? "Enrolling.." : "Enroll"}
                    </Button>
                  </Col>
                )}

              {/* View courses when no one has logged in */}
      {/* {!isLoggedIn && (
                <Col>
                  <Link to="/login">
                    <Button
                      className="mx-3 bg-blue-500 flex justify-content-center align-items-center"
                      icon={<LoginOutlined />}
                      type="primary"
                    >
                      {" "}
                      Login
                    </Button>
                  </Link>
                </Col>
              )}
            </Row>
          </div>,
        ]}
      >
        <Meta
          avatar={
            <Avatar src="https://xsgames.co/randomusers/avatar.php?g=pixel" />
          }
          title={title}
          description={description}
        />
      </Card> */}
      <div className="container mx-auto">
        <div
          className="flex flex-wrap -mx-4"
          style={{
            width: "300px",
            margin: "20px",
            borderRadius: "10px",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
          }}
        >
          <div className="w-full">
            <div className="relative pb-48 overflow-hidden">
              <Link
                to={
                  isLoggedIn ? `/dashboard/courses/${id}` : `/viewCourse/${id}`
                }
                className="c-card block bg-white shadow-md hover:shadow-xl rounded-lg overflow-hidden"
              >
                <img
                  className="absolute inset-0 h-full w-full object-cover rounded-lg"
                  src={imageUrl}
                  alt=""
                />
              </Link>
            </div>
            <div className="p-4">
              <span className="inline-block px-2 py-1 leading-none bg-orange-200 text-orange-800 rounded-full font-semibold uppercase tracking-wide text-xs">
                {price > 0 ? "PAID" : "FREE"}
              </span>
              <h2 className="mt-2 mb-2  font-bold">{title}</h2>
              <p className="text-sm">{description}</p>
              <div className="mt-3 flex items-center">
                <span className="text-sm font-semibold">Fee</span>&nbsp;
                <span className="font-bold text-xl">{price}</span>&nbsp;
                <span className="text-sm font-semibold">Rs</span>
              </div>
            </div>
            <div className="px-4 py-2 border-t border-b text-xs text-gray-700">
              <Space size={[0, 8]} wrap>
                <h4 className="text-sm font-semibold mr-2">Tags: </h4>
                {tags &&
                  tags[0]?.split(",")?.map((tag, index) => {
                    if (tag != "undefined") {
                      return (
                        <Tag
                          color={
                            tags_colors[
                              Math.floor(Math.random() * tags_colors.length)
                            ]
                          }
                          key={index}
                        >
                          {tag}
                        </Tag>
                      );
                    }
                  })}
              </Space>
            </div>
            <div className="px-2 py-2 flex items-center text-sm text-gray-600">
              {isLoggedIn && getuser?.result?.Courses?.indexOf(id) != -1 && (
                <Col className="flex justify-between flex-row py-3 w-100">
                  {isLoggedIn && (
                    <Link to={`/dashboard/courses/${id}`}>
                      <Button
                        className={`mx-3 bg-pink-500 hover:bg-pink-400 w-${
                          getuser?.result?.isTeacher ? "40" : "60"
                        }`}
                        icon={<CheckCircleOutlined />}
                        type="primary"
                      >
                        {getuser?.result?.isTeacher ? "Open" : "Enrolled"}
                      </Button>
                    </Link>
                  )}
                  {isLoggedIn && getuser.result.isTeacher && (
                    <Button
                      className=""
                      icon={<Trash3Fill />}
                      loading={deleting}
                      type="link"
                      danger
                      onClick={handleDeleteCourse}
                    >
                      {deleting ? "Deleting..." : "Delete"}
                    </Button>
                  )}
                </Col>
              )}
              {isLoggedIn &&
                !getuser?.result?.isTeacher &&
                getuser?.result?.Courses?.indexOf(id) === -1 && (
                  <Col>
                    <Button
                      className="mx-3 bg-green-500 hover:bg-green-400"
                      icon={<HouseAddFill />}
                      type="primary"
                      loading={enrolling}
                      onClick={handleEnroll}
                    >
                      {enrolling ? "Enrolling.." : "Enroll"}
                    </Button>
                  </Col>
                )}

              {/* View courses when no one has logged in */}
              {!isLoggedIn && (
                <Col>
                  <Link to="/login">
                    <Button
                      className="mx-3 bg-blue-500 flex justify-content-center align-items-center"
                      icon={<LoginOutlined />}
                      type="primary"
                    >
                      {" "}
                      Login
                    </Button>
                  </Link>
                </Col>
              )}
            </div>
          </div>
        </div>
      </div>
      {showPayment && (
        <Payment visible={showPayment} onCancel={handlePaymentCancel} />
      )}
    </>
  );
};

export default CourseCard;

const tags_colors = [
  "magenta",
  "red",
  "volcano",
  "orange",
  "gold",
  "lime",
  "green",
  "cyan",
  "blue",
  "geekblue",
  "purple",
];
